import cargas_services_irge from '../cargas_services_irge'

const api_cargas_irge = {}


api_cargas_irge.getCargas = async function (form) {

  const options = {
    method: 'POST',
    url: '/api/getCargasIRGE',
    headers: {'Content-Type': 'application/json'},
    data: form
  }

  const data = await cargas_services_irge(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

api_cargas_irge.getCargasFaltantes = async function (form) {

  const options = {
    method: 'POST',
    url: '/api/getFaltantesIRGE',
    headers: {'Content-Type': 'application/json'},
    data: form
  }

  
  const data = await cargas_services_irge(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

export default api_cargas_irge


// WEBPACK FOOTER //
// ./src/services/sca/apiCargasIrge.js